<div class="wcm-erp modal-view">
  <app-detail-header [breadcrumbsData]="breadcrumbsData">
    <ng-template appDetailHeaderRight>
      <div *ngIf="mode === 'normal'">
        <button type="button" class="btn btn-default" (click)="edit()">
          Modifier
        </button>
      </div>
      <div *ngIf="mode === 'edition'">
        <button type="button" class="btn btn-primary" (click)="save()" *ngIf="!detail.code"
                [disabled]="f.invalid || loading">
          Créer
        </button>
        <button type="button" class="btn btn-primary" (click)="save()" *ngIf="detail.code"
                [disabled]="f.invalid || loading">
          Enregistrer
        </button>
        <button type="button" class="btn btn-default" (click)="cancel()" *ngIf="detail.code">
          Annuler
        </button>
      </div>
    </ng-template>
  </app-detail-header>

  <form class="form-horizontal" #f="ngForm" (ngSubmit)="save()">
    <!-- this submit button is here to trigger the submit when the user presses the enter key -->
    <!-- the form (ngSubmit) function will be in charge of handling the call -->
    <button type="submit" [hidden]="true"></button>
    <div class="form-group">
      <label class="col-sm-2 control-label">
        Code
      </label>
      <div class="col-sm-4">
        <p class="form-control-static">
          {{detail.code}}
        </p>
      </div>

      <label class="col-sm-2 control-label">
        Raison sociale <i class="required">*</i>
      </label>
      <div class="col-sm-4">
        <input class="form-control wcm-highlight-req"
               name="name" [required]="true"
               [readonly]="mode === 'normal'"
               [(ngModel)]="detail.name" />
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6"></div>

      <label class="col-sm-2 control-label">
        Raison sociale effective
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="effective_name"
               [required]="true"
               [readonly]="mode === 'normal'"
               [(ngModel)]="detail.effective_name" />
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Préfixe <i class="required">*</i>
      </label>
      <div class="col-sm-4">
        <input class="form-control wcm-highlight-req"
               name="prefix" [required]="true"
               [readonly]="mode === 'normal'"
               pattern="^[A-Z]{3}$"
               [(ngModel)]="detail.prefix" />
        <div class="error-message" *ngIf="f.controls.prefix?.errors?.pattern">
          Format du préfixe invalide, il doit être composé d'exactement 3 majuscules.
        </div>
      </div>

      <label class="col-sm-2 control-label">
        ICS <i class="required">*</i>
      </label>
      <div class="col-sm-4">
        <input class="form-control wcm-highlight-req"
               name="ics_code" [required]="true"
               [readonly]="mode === 'normal'"
               [(ngModel)]="detail.ics_code" />
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Sender
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="sender"
               [readonly]="mode === 'normal'"
               [(ngModel)]="detail.dynamics_sender" />
      </div>
      <label class="col-sm-2 control-label" *ngIf="hasPermissions('Antoine:CanBypassICMA')">
        Bypass ICMA Contrôle
      </label>
      <div class="col-sm-4" *ngIf="hasPermissions('Antoine:CanBypassICMA')">
          <div class="checkbox">
            <p-checkbox
              name="bypass_icma_control"
              [(ngModel)]="detail.bypass_icma_control"
              [binary]="true" inputId="bypassICMAControl"
              [readonly]="mode === 'normal'">
            </p-checkbox>
          </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Data Area
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="dataarea"
               [readonly]="mode === 'normal'"
               [(ngModel)]="detail.dynamics_dataarea" />
      </div>
      <label class="col-sm-2 control-label">
        SIRET
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="siret"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="detail.siret" />
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Adresse <i class="required">*</i>
      </label>
      <div class="col-sm-4">
        <app-location-field class="wcm-highlight-req"
                            [filters]="{source__nin: 'orch'}"
                            name="location" [required]="true"
                            [disabled]="mode === 'normal'"
                            [(ngModel)]="detail.location">
        </app-location-field>
      </div>
      <label class="col-sm-2 control-label">
        SIREN
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="siren"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="detail.siren" />
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Pied de page
      </label>
      <div class="col-sm-4">
        <textarea class="form-control vertical-resize resize-when-editing"
                  name="invoice_footer"
                  [disabled]="mode === 'normal'"
                  [(ngModel)]="detail.invoice_footer"
                  rows="3">
        </textarea>
      </div>
      <label class="col-sm-2 control-label" >
        Code TVA
      </label>
      <div class="col-sm-4">
        <input class="form-control"
               name="code_tva"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="detail.code_tva" />
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">
        Conditions générales additionnelles
      </label>
      <div class="col-sm-4">
        <textarea class="form-control vertical-resize resize-when-editing"
                  name="invoice_terms"
                  [disabled]="mode === 'normal'"
                  [(ngModel)]="detail.invoice_terms"
                  rows="8">
        </textarea>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">
        Réserve de propriété
      </label>
      <div class="col-sm-4">
        <textarea class="form-control vertical-resize resize-when-editing"
                  name="property_reservation"
                  [disabled]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
                  [(ngModel)]="detail.property_reservation"
                  rows="8">
        </textarea>
      </div>
    </div>
  </form>

  <ng-container *ngIf="detail.id">
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav-pills" [destroyOnHide]="false" (activeIdChange)="onTabChange($event)" [activeId]="activeTab">
      <li [ngbNavItem]="0">
        <a ngbNavLink>Comptes</a>
        <ng-template ngbNavContent>
          <app-accounts-list [disableUrlUpdate]="true" [filters]="accountsList.filters"
                             [disabledColumns]="accountsList.disabledColumns"
                             *ngIf="tabsStatus[0]">
          </app-accounts-list>
        </ng-template>
      </li>

      <li [ngbNavItem]="1">
        <a ngbNavLink>Mentions Légales</a>
        <ng-template ngbNavContent>
          <app-invoice-notes-tab [company]="detail" *ngIf="tabsStatus[1]">
          </app-invoice-notes-tab>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>Données bancaires</a>
        <ng-template ngbNavContent>
          <div class="text-center">
            <app-bank-data-tab [company]="detail" [mode]="mode" *ngIf="tabsStatus[2]">
            </app-bank-data-tab>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink>Contact</a>
        <ng-template ngbNavContent>
          <form class="form-horizontal" #f="ngForm" (ngSubmit)="save()">
            <div *ngIf="tabsStatus[3]">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Nom du contact
                </label>
                <div class="col-sm-4">
                  <input class="form-control"
                         name="contact_name"
                         [readonly]="mode === 'normal'"
                         [(ngModel)]="detail.contact_name" />
                </div>
                <label class="col-sm-2 control-label">
                  Téléphone
                </label>
                <div class="col-sm-4">
                  <input class="form-control"
                         name="contact_phone"
                         [readonly]="mode === 'normal'"
                         [(ngModel)]="detail.contact_phone" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Email du contact
                </label>
                <div class="col-sm-4">
                  <input class="form-control"
                         name="contact_email"
                         [readonly]="mode === 'normal'"
                         [(ngModel)]="detail.contact_email" />
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </li>
      <li [ngbNavItem]="4">
        <a ngbNavLink>Traductions</a>
        <ng-template ngbNavContent>
          <app-translations-list model="company" [item]="detail" [disableUrlUpdate]="true" *ngIf="tabsStatus[3]">
          </app-translations-list>
        </ng-template>
      </li>
      <li [ngbNavItem]="5">
        <a ngbNavLink>Historique</a>
        <ng-template ngbNavContent>
          <app-model-histories-list *ngIf="tabsStatus[4]" [id]="detail.id" model="company">
          </app-model-histories-list>
        </ng-template>
      </li>
    </ul>
    <!-- The tabs content is dislayed inside the outlet -->
    <div [ngbNavOutlet]="nav"></div>
  </ng-container> <!-- /tabs container -->
</div>
